import { Components, Theme } from '@mui/material'
import { mixins } from '../mixins'
import { palette } from '../palette'

declare module '@mui/material/Radio' {
  interface RadioProps {
    'data-is-ai-prefilled'?: boolean
  }
}

export const MuiRadio: Components<Omit<Theme, 'components'>>['MuiRadio'] = {
  defaultProps: {
    size: 'small',
  },
  styleOverrides: {
    root: ({ 'data-is-ai-prefilled': dataIsAiPrefilled }) => ({
      '& + .MuiFormControlLabel-label': {
        marginTop: 'auto !important',
        marginBottom: 'auto !important',
        '.MuiStack-root': {
          marginBottom: 0,
        },
        fontSize: '14px',
      },
      '&.Mui-disabled': {
        path: { fill: palette.neutralLight[700] },
      },
      padding: mixins.paddingRadioCheckbox,
      ...(dataIsAiPrefilled && {
        '&:not(.Mui-disabled)': {
          path: { fill: palette.secondary.main },
        },
      }),
    }),
  },
}
